import React, { useEffect, useState } from "react";
import api from "../../api/api";
import { Autocomplete } from "../../components/Autocomplete";
import { Input } from "../../components/Input";
import moment from "moment";
import { StatisticsChart, statisticsAxis, statisticsNumberAxis, statisticsGrid, statisticsTooltip } from "../../components/StatisticsChart";
import {
  BarChart,
  Bar,
  Rectangle,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  Line,
  LineChart,
  AreaChart,
  Area,
  Cell,
  LabelList,
} from "recharts";

export const Clienti = ({ screenSize, f24, dataF24 }) => {
  const [dataA, setDataA] = useState(moment(new Date()).format("YYYY-MM"));
  const [dataDa, setDataDa] = useState(
    moment(new Date()).subtract(6, "months").format("YYYY-MM")
  );
  const [parcellazione, setParcellazione] = useState([]);
  const [aziende, setAziende] = useState([]);
  const [aziendaSel, setAziendaSel] = useState(null);

  useEffect(() => {}, [screenSize]);

  const loadClienti = async (dataDa) => {
    const aziende = await api.get("/aziende");
    let aziende_filtered = aziende.data.filter((el) => {
      // Include aziende senza data_fine_elaborazioni o con data_fine >= inizio periodo
      if (
        !el.data_fine_elaborazioni ||
        moment(el.data_fine_elaborazioni).isSameOrAfter(moment(dataDa).startOf('month'))
      ) {
        return true;
      } else {
        return false;
      }
    });
    console.log(aziende_filtered);
    setAziende(aziende_filtered);
  };

  const loadParcellazione = async (da, a, az) => {
    const parc = await api.get(`/parcellazione/${az}`, {
      params: { da: da, a: a },
    });
    setParcellazione(parc.data);
  };

  useEffect(() => {
    //carico clienti subito
    loadClienti(dataDa, dataA);
    //
  }, []);

  useEffect(() => {
    if ((aziendaSel, dataDa, dataA)) {
      loadClienti(dataDa, dataA);
      loadParcellazione(
        moment(dataDa).format("YYYY-MM"),
        moment(dataA).format("YYYY-MM"),
        aziendaSel
      );
    }
  }, [aziendaSel, dataDa, dataA]); //se cliente sel, carico allora il grafico

  const handleChangeAzienda = async (e) => {
    setAziendaSel(e.target.value);
  };

  return (
    <div className="el-container h-fit ">
      <div className="flex flex-wrap gap-2 items-end">
        <div className="w-full sm:w-44">
          <Input
            type="month"
            label={"Da"}
            name="da"
            value={dataDa}
            onChange={async (e) => {
              await setDataDa(e.target.value);
              //loadParcellazione(moment(e.target.value).format("YYYY-MM"),moment(dataA).format("YYYY-MM"))
            }}
            max={moment(dataA).format("YYYY-MM")}
          />
        </div>
        <div className="w-full sm:w-44">
          <Input
            type="month"
            label={"A"}
            name="a"
            onChange={async (e) => {
              await setDataA(e.target.value);
              //loadParcellazione(moment(dataDa).format("YYYY-MM"),moment(e.target.value).format("YYYY-MM"))
            }}
            min={moment(dataDa).format("YYYY-MM")}
            value={dataA}
          />
        </div>
        <div className="w-full sm:w-64">
          {/* Stessa selezione cliente del listino: ricerca + badge lettera Z/B/I colorato */}
          <Autocomplete
            label={"Azienda"}
            name="aziende"
            onChange={handleChangeAzienda}
            value={aziendaSel}
            placeholder="Cerca cliente..."
            options={aziende.map((el) => ({
              id: el.codice_univoco,
              name: el.ragione_sociale,
              badge: el.tipologia_fatturazione,
            }))}
          />
        </div>
      </div>

      <StatisticsChart title="Andamento cedolini per cliente" subtitle="Cedolini mensili nel periodo selezionato" count={parcellazione.length}>
          <ResponsiveContainer width="100%" height="100%">
            <BarChart
              width={500}
              height={300}
              data={parcellazione}
              margin={{
                top: 28,
                right: 30,
                left: 20,
                bottom: 5,
              }}
            >
              <CartesianGrid {...statisticsGrid} />
              <XAxis {...statisticsAxis} dataKey="meseanno" />
              <YAxis {...statisticsNumberAxis} />
              <Tooltip {...statisticsTooltip} />
              <Legend iconType="circle" wrapperStyle={{ fontSize: 12, paddingTop: 10 }} />
              <Bar
                dataKey="cedolini_normali"
                name="Cedolini normali"
                fill="#2563EB" radius={[10, 10, 0, 0]} maxBarSize={150}
                activeBar={<Rectangle fill="#60A5FA" stroke="#2563EB" radius={[10, 10, 0, 0]} />}
              >
                <LabelList
                  dataKey="cedolini_normali"
                  position="top"
                  offset={8}
                  fill="#1E293B"
                />
              </Bar>
            </BarChart>
          </ResponsiveContainer>
      </StatisticsChart>
    </div>
  );
};
